<template>
  <div>
    <div class="modal right fade" :ref="componentID" :id="componentID" tabindex="-1" role="dialog" aria-modal="true">
      <div class="modal-dialog" role="document">
        <button type="button" class="close md-close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
        <div class="modal-content">

          <div class="modal-header">
            <button type="button" class="close xs-close" data-dismiss="modal">×</button>
            <div class="row w-100">
              <span class="pl-5">{{currentGap.category}}</span>
            </div>

          </div>

          <div class="card due-dates">
            <div class="card-body">
              <div class="row">
                <div class="col">
                  <span>Kategorie</span>
                  <p>{{currentGap.category}}</p>
                </div>
                <div class="col">
                  <span>Interne Nummer</span>
                  <p>{{currentGap.internal_number}}</p>
                </div>
                <div class="col">
                  <span>Priorität</span>
                  <p>{{currentGap.priority}}</p>
                </div>
                <div class="col">
                  <span>Dokument</span>
                  <p>{{currentGap.intern_document}}</p>
                </div>
              </div>
            </div>
          </div>

          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <div class="crms-tasks">
                  <h2>Gap Analyse</h2>
                  <survey :survey="survey"></survey>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div><!-- modal-content -->
    </div>
    <!-- Survey help box modal -->
    <div class="modal" id="modal-help">
      <div class="modal-dialog">
        <div class="modal-content">

          <!-- Modal Header -->
          <div class="modal-header">
            <h4 class="modal-title">Erläuterung</h4>
            <button type="button" class="close" @click.stop.prevent="close_help">&times;</button>
          </div>

          <!-- Modal body -->
          <div class="modal-body">
            {{ help_text }}
          </div>

          <!-- Modal footer -->
          <div class="modal-footer">
            <button type="button" class="btn btn-danger btn-sm" @click.stop.prevent="close_help">schließen</button>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as SurveyVue from 'survey-vue';
import "survey-vue/defaultV2.css";
import * as widgets from "surveyjs-widgets";
import {init as customWidget} from "@/components/survey/customwidget";
import make_question_survey from "@/utils/survey_utils";
import {required} from "@vuelidate/validators";
import {useVuelidate} from "@vuelidate/core";
import {mapState} from "vuex";
import {objectModalName} from "@/utils/enums";
SurveyVue.StylesManager.applyTheme("defaultV2");
const Survey = SurveyVue.Survey;

// widgets.icheck(SurveyVue);
widgets.select2(SurveyVue);
widgets.inputmask(SurveyVue);
widgets.jquerybarrating(SurveyVue);
widgets.jqueryuidatepicker(SurveyVue);
widgets.nouislider(SurveyVue);
widgets.select2tagbox(SurveyVue);
widgets.sortablejs(SurveyVue);
widgets.ckeditor(SurveyVue);
widgets.autocomplete(SurveyVue);
widgets.bootstrapslider(SurveyVue);
customWidget(SurveyVue);
export default {
  name: "GapSurveyComponent",
  props: {
    currentGap: {
      type: Object,
      required: true,
    },
    componentID: {
      type: String,
      default: objectModalName.questionSurvey
    },
  },
  data() {
    return {
      currentAnswer: {},
      addNewAnswer: false,
      surveyJSON: {},
      help_text: ''
    }
  },
  validations() {
    return {
      currentGap: {
        id: {required, $lazy: true},
        description: {required, $lazy: true}
      },
      newAnswer: {
        comments: {required, $lazy: true}
      },
      $validationGroups: {
        GapGroup: ['currentGap', 'newAnswer'],
      }
    }
  },
  setup() {
    return {
      v$: useVuelidate()
    }
  },
  computed: {
    ...mapState({accountid: state => state.account.accountid, userName: state => state.user.username, account: state => state.account, userID: state => state.user.id, edit: state => state.app.edit}),
    survey() {
      if (this.surveyJSON && this.currentGap.id) return this.initSurvey()
      return new SurveyVue.Model('')
    }
  },
  methods: {
    submitAnswer: function(survey_result) {
      let return_data = []
      let data = []
      let current_answer = {}
      let question_id = ''
      let question_answer = {}
      let active = true
      const that = this
      for (const [key, value] of Object.entries(survey_result.data)) {
        if (key.substring(key.length - 9) === '-Document' || key.substring(key.length - 8) === '-Comment') {
          question_id = key.substring(8, key.indexOf('-'))
          let current_element = return_data.find(function(element) {
            return element.question === question_id
          })
          if (key.substring(key.length - 9) === '-Document') {
            current_element.question_answer.document = { 'name': value.name, 'path': value.path, 'version': value.version }
          } else current_element.question_answer.comment = value
        } else {
          question_id = key.substring(8)
          question_answer = { 'answer': value, 'comment': '', 'document': {}}
          active = true
          current_answer = { 'question': question_id, 'question_answer': question_answer, 'active': active,
            'modified_by': that.$store.getters.id }
          return_data.push(current_answer)
        }
      }
      if (that.original_answers.length > 0) {
        return_data.forEach(function(item, index) {
          let original_answer = that.original_answers.find(element => {
            return String(element.question) === String(item.question)
          })
          if (original_answer !== undefined) {
            if (JSON.stringify(original_answer.question_answer) !== JSON.stringify(item.question_answer)) {
              data.push(item)
            }
          } else {
            data.push(item)
          }
        })
      }
      service.request({
        url: 'todos/v1/answers/',
        method: 'POST',
        data: { 'answers': data },
        contentType: 'application/json; charset=utf-8'
      }).then(function(response) {
        console.log('ready')
      }).catch(function(err) {
        console.log(err)
      })
    },
    initSurvey: function() {
      const that = this
      this.surveyJSON = make_question_survey(this.currentGap)
      this.original_answers = this.currentGap.answers
      let answers = {}
      let answers_remark = {}
      this.original_answers.forEach(function(item, index) {
        answers_remark['question' + item.question] = 'Eingetragen am ' + item.modified_on +
          ' von ' + item.modified_by
        answers['question' + item.question] = item.question_answer.answer
        if (item.question_answer.comment !== '') {
          answers['question' + item.question + '-Comment'] = item.question_answer.comment
        }
        if (item.question_answer.document !== {}) {
          answers['question' + item.question + '-Document'] = item.question_answer.document
        }
      })
      this.survey_pages = JSON.parse(this.surveyJSON)['pages']
      SurveyVue.JsonObject.metaData.addProperty('question', 'help_text:text')
      SurveyVue.JsonObject.metaData.addProperty('page', 'help_text:text')
      SurveyVue.JsonObject.metaData.addClass('ddk_radiogroup', [{ name: 'hasComment', visible: false },
        { name: 'hasOther', visible: false }, { name: 'choices', visible: false }], null, 'radiogroup')
      function isCommentRequired(value) {
        return value === 'teilweise' || value === 'nicht_zutreffend'
      }

      function isDDKRadioQuestion(question) {
        return !!question && question.getType() === 'ddk_radiogroup'
      }

      function onDDK_RadioValueChanged(sender, options) {
        if (!isDDKRadioQuestion(options.question)) return
        let commentText = 'Bemerkung'
        if (isCommentRequired(options.value)) {
          commentText += ' **'
        }
        commentText += ':'
        options.question.commentText = commentText
      }

      function onDDK_RadioValidateQuestion(sender, options) {
        if (!isDDKRadioQuestion(options.question)) return
        if (isCommentRequired(options.value) && !options.question.comment) {
          options.error = 'Bitte Bemerkungen eintragen'
        }
      }
      function showDescription(element) {
        that.help_text = element
        $('#modal-help').show();
      }
      const model = new SurveyVue.Model(that.surveyJSON)
      model.onValueChanged.add(function(survey, options) {
        console.log(options)
        onDDK_RadioValueChanged;
        switch(options.value){
          case 'ja':
            options.question.comment = that.currentGap.statement_yes;
            break;
          case 'nein':
            options.question.comment = that.currentGap.statement_no;
            break;
          case 'teilweise':
            options.question.comment = that.currentGap.statement_partial;
            break;
          case 'nicht_zutreffend':
            options.question.comment = that.currentGap.statement_irrelevant;
            break;
        }
      })
      model.onValidateQuestion.add(
        onDDK_RadioValidateQuestion
      )
      model.onAfterRenderQuestion.add(function(survey, options) {
        // Return if there is no description to show in popup
        // console.log(options.question.help_text)
        if (!options.question.help_text) return
        // Add a button;
        const btn = document.createElement('button')
        btn.type = 'button'
        btn.className = 'btn btn-info btn-xs'
        btn.innerHTML = 'More Info'
        const question = options.question
        btn.onclick = function() { showDescription(question.help_text) }
        const header = options.htmlElement.querySelector('h5')
        const span = document.createElement('span')
        const span_text = document.createElement('span')
        span.innerHTML = '  '
        span_text.innerHTML = '<b style="color: red">' + answers_remark[question.name] + '</b>'
        header.appendChild(span)
        header.appendChild(btn)
        if (answers_remark[question.name] !== undefined) {
          header.appendChild(span)
          header.appendChild(span_text)
        }
      })
      model.onAfterRenderPage.add(function(survey, options) {
        // Return if there is no description to show in popup
        if (!options.page.help_text) return
        // Add a button;
        const btn = document.createElement('button')
        btn.type = 'button'
        btn.className = 'btn btn-info btn-xs'
        btn.innerHTML = 'More Info'
        const page = options.page
        btn.onclick = function() { showDescription(page.help_text) }
        const header = options.htmlElement.querySelector('h4')
        const span = document.createElement('span')
        span.innerHTML = '  '
        header.appendChild(span)
        header.appendChild(btn)
      })
      model.onComplete.add(that.submitAnswer)
      model.data = answers
      return model
    },
    close_help() {
      $('#modal-help').hide()
    },
  }
}
</script>

<style scoped>

/* modal backdrop fix */
.modal:nth-of-type(even) {
  z-index: 1052 !important;
}
.modal:nth-of-type(odd) {
  z-index: 1050 !important;
}

</style>
